<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش اعلان ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-select color="black" v-model="order" label="نوع ترتیب اعلان ها را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getNotifications"></v-select>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model="needle" hint="شامل عنوان و محتوا"
                          label="در محتوای اعلان جستجو کنید." color="black">
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn @click="getNotifications()" class="mt-4" elevation="0" color="info"
                   style="letter-spacing: normal!important">
              جستجو
            </v-btn>
          </v-col>
          <v-col cols="4" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/notifications/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات اعلان ها</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/notifications/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت اعلان جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                :headers="headers"
                :items="notifications"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-switch
                      v-model="singleExpand"
                      label="فقط یک سطر باز شود."
                      class="mt-2"
                  ></v-switch>
                </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="4">مربی :
                      {{ item.instructor_name }}
                    </v-col>
                    <v-col cols="4">هنرجو :
                      {{ item.student_name }}
                    </v-col>
                    <v-col cols="4">مدیر :
                      {{ item.admin_name }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">محتوا :
                      {{ item.content }}
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/notifications/edit/'+item.id)">mdi-pen
                </v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
                <v-icon color="success" @click="$router.push(item.url)">mdi-language-go</v-icon>
              </template>
              <template
                  v-slot:[`item.section`]="{ item }">
                <span v-if="item.section === 'change_program'">
                  تغییر در برنامه
                </span>
                <span v-else-if="item.section === 'concert'">
                  کنسرت
                </span>
                <span v-else-if="item.section === 'news'">
                  خبر
                </span>
                <span v-else-if="item.section === 'offer'">
                  پیشنهاد
                </span>
                <span v-else-if="item.section === 'general'">
                  عمومی
                </span>
              </template>
              <template
                  v-slot:[`item.has_sound_alert`]="{ item }">
                <span v-if="item.has_sound_alert">
                  <v-icon color="success">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </span>
              </template>
              <template
                  v-slot:[`item.has_attachment`]="{ item }">
                <span v-if="item.has_attachment">
                  <v-icon color="success">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </span>
              </template>
              <template
                  v-slot:[`item.show_after_login`]="{ item }">
                <span v-if="item.show_after_login">
                  <v-icon color="success">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </span>
              </template>
              <template
                  v-slot:[`item.has_schedule`]="{ item }">
                <span v-if="item.has_schedule">
                  <v-icon color="success">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </span>
              </template>

              <template
                  v-slot:[`item.attachment_type`]="{ item }">
                <span v-if="item.attachment_type === 'zip'">
                  فایل فشرده
                </span>
                <span v-else-if="item.attachment_type === 'audio'">
                  صوتی
                </span>
                <span v-else-if="item.attachment_type === 'video'">
                  ویدیو
                </span>
                <span v-else-if="item.attachment_type === 'pdf'">
                  پی دی اف
                </span>
                <span v-else-if="item.attachment_type === 'image'">
                  تصویر
                </span>
              </template>

              <template
                  v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'draft'">پیش نویس</span>
                <span v-if="item.status === 'waiting'">در انتظار ارسال</span>
                <span v-if="item.status === 'sent'">ارسال شده</span>
                <span v-if="item.status === 'cancelled'">کنسل شده</span>
                <span v-if="item.status === 'failed'">ناموفق</span>
                <span v-if="item.status === 'visited'">دیده شده</span>
              </template>

              <template
                  v-slot:[`item.priority`]="{ item }">
                <span v-if="item.priority === 'low'">کم</span>
                <span v-if="item.priority === 'normal'">متوسط</span>
                <span v-if="item.priority === 'high'">زیاد</span>
              </template>

              <template
                  v-slot:[`item.color`]="{ item }">
                <div class="color-box" :style="'background-color:'+item.color+'!important'">
                  &nbsp;
                </div>
              </template>

              <template
                  v-slot:[`item.visibility`]="{ item }">
                <span v-if="item.visibility">قابل مشاهده</span>
                <span v-else>مخفی</span>
              </template>
              <template
                  v-slot:[`item.select`]="{ item }">
                <v-checkbox color="black" v-model="selectedNotificationIds[item.id]">
                </v-checkbox>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" class="text-left">
            <v-btn @click="destroyMulti" color="error" style="letter-spacing: normal!important">
              پاک کردن گروهی
            </v-btn>
          </v-col>
          <v-col cols="12" class="text-left">
            <v-pagination
                color="#696CFF"
                v-model="notifications.current_page"
                :length="notifications.last_page"
                circle
                @input="getNotifications"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "NotificationMy",
  data() {
    return {
      expanded: [],
      singleExpand: false,
      selectedNotificationIds: [],
      loading: true,
      needle: null,
      orderItems: [
        {name: 'بر اساس عنوان', value: 'title'},
        {name: 'بر اساس اولویت', value: 'priority'},
        {name: 'بر اساس بخش', value: 'section'},
        {name: 'بر اساس نوع ضمیمه', value: 'attachment_type'},
        {name: 'بر اساس وضعیت', value: 'status'},
        {name: 'بر اساس تاریخ ساخت', value: 'created_at'},
      ],
      order: 'created_at',
      notifications: [],
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'عنوان', value: 'title', align: 'center', width: '10%'},
        {text: 'اولویت', value: 'priority', align: 'center', width: '10%'},
        {text: 'بخش', value: 'section', align: 'center', width: '5%'},
        {text: 'رنگ', value: 'color', align: 'center', width: '5%'},
        {text: 'وضعیت صدا', value: 'has_sound_alert', align: 'center', width: '5%'},
        {text: 'ضمیمه', value: 'has_attachment', align: 'center', width: '5%'},
        {text: 'نمایش پس از ورود', value: 'show_after_login', align: 'center', width: '5%'},
        {text: 'وضعیت زمان بندی', value: 'has_schedule', align: 'center', width: '5%'},
        {text: 'نوع ضمیمه', value: 'attachment_type', align: 'center', width: '10%'},
        {text: 'فرستاده شده در', value: 'send_at_fa', align: 'center', width: '10%'},
        {text: 'وضعیت', value: 'status', align: 'center', width: '10%'},
        {text: 'تاریخ ساخت', value: 'created_at_fa', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '10%'},
        {text: 'انتخاب', value: 'select', align: 'right', width: '10%'},
      ],
    }
  },
  mounted() {
    this.getNotifications()
  },
  methods: {
    getNotifications() {
      let url = '/instructor/notification/index/all'
      window.axios.get(url).then((res) => {
        this.notifications = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(notificationId) {
      window.axios.delete('notification/crud/delete/' + notificationId).then(() => {
        this.getNotifications()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroyMulti() {
      window.axios.post('notification/crud/multiple/delete', {
        ids: this.selectedNotificationIds
      }).then(() => {
        this.getNotifications()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>

<style scoped>
.color-box {
  width: 40px !important;
  height: 40px !important;
  border-radius: 8px !important;
}
</style>